import { Action, createReducer, on } from '@ngrx/store';
import { IPMessage } from '../../models/pmessage.model';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { CountryItem, EnumMediaEntities, MediaTypeItem } from '../../../api/models';
import { commonActions } from './common.actions';
import { MenuItem } from 'primeng/api';

export interface CommonState {
  countries: {
    state: ILoaderActionPayload;
    data?: CountryItem[];
  };
  mediaTypes: {
    type: EnumMediaEntities;
    state: ILoaderActionPayload;
    data?: MediaTypeItem[];
  }[];
  breadcrumb: {
    state: ILoaderActionPayload;
    data?: MenuItem[];
  };
}

const initialState: CommonState = {
  countries: { state: { value: LoadingState.NONE } },
  mediaTypes: [{ type: EnumMediaEntities.user, state: { value: LoadingState.NONE } }],
  breadcrumb: {
    state: {
      value: LoadingState.NONE,
    },
  },
};

const reducer = createReducer(
  initialState,
  // load
  on(commonActions.loadCountries, (state) => ({
    ...state,
    countries: { state: { value: LoadingState.LOADING } },
  })),
  on(commonActions.doneLoadCountries, (state, props) => ({
    ...state,
    countries: { state: props.state, data: props.data },
  })),
  // load
  on(commonActions.loadMediaTypes, (state, action) => ({
    ...state,
    mediaTypes: state.mediaTypes.map((element) => ({
      ...(element.type === action.entity
        ? { type: action.entity, state: { value: LoadingState.LOADING }, data: undefined }
        : { ...element }),
    })),
  })),
  on(commonActions.doneMediaTypes, (state, props) => ({
    ...state,
    mediaTypes: state.mediaTypes.map((element) => ({
      ...(element.type === props.entity
        ? { type: props.entity, state: props.state, data: props.data }
        : { ...element }),
    })),
  })),

  // breadcrumb
  on(commonActions.setBreadcrumb, (state, { data }) => ({
    ...state,
    breadcrumb: { state: { value: LoadingState.SUCCESS }, data },
  })),
  on(commonActions.clearBreadcrumb, (state) => ({
    ...state,
    breadcrumb: { state: { value: LoadingState.NONE }, data: undefined },
  })),
);

export function commonReducer(state: CommonState | undefined, action: Action) {
  return reducer(state, action);
}
